/**
 * Estado de rede do navegador (offline, item 2 de 02/09).
 *
 * `navigator.onLine` + os eventos `online`/`offline` da `window`, que o
 * WKWebView também dispara a partir da reachability do sistema. Não é prova
 * de que o servidor responde (rede "conectada" sem rota existe), então quem
 * lê isto trata `false` como certeza de offline e `true` como "talvez".
 *
 * `useSyncExternalStore`, não `useState` + efeito: a regra
 * `react-hooks/set-state-in-effect` está ativa para código novo, e o
 * snapshot é um booleano, então nunca dispara o laço de "snapshot instável".
 * Sem `window` (SSR, jsdom sem navigator) responde `true`: a faixa de
 * offline é a exceção, e a ausência de dado não pode acendê-la.
 */
import { useSyncExternalStore } from "react";

function subscribe(onChange: () => void): () => void {
  window.addEventListener("online", onChange);
  window.addEventListener("offline", onChange);
  return () => {
    window.removeEventListener("online", onChange);
    window.removeEventListener("offline", onChange);
  };
}

export function readOnlineStatus(): boolean {
  if (typeof navigator === "undefined") return true;
  return navigator.onLine !== false;
}

const serverSnapshot = () => true;

/** `true` = online (ou desconhecido); `false` = o navegador afirma offline. */
export function useOnlineStatus(): boolean {
  return useSyncExternalStore(subscribe, readOnlineStatus, serverSnapshot);
}
